/**
 * TODO (temporário — LPPJ-1258): remover quando o backend/CDN parar de enviar
 * a logo antiga da Stone em layout_settings.image_url.
 * Thread: https://stonepgto.slack.com/archives/C05NFPHTNHK/p1787937636946909
 */
const LEGACY_STONE_LOGO = {
  host: 'link.stone.com.br',
  pathname: '/static/logo_stone.png',
};

export const isLegacyStoneLogo = (url?: string): boolean => {
  if (!url) return false;

  try {
    const { host, pathname } = new URL(url);
    return (
      host === LEGACY_STONE_LOGO.host &&
      pathname === LEGACY_STONE_LOGO.pathname
    );
  } catch {
    return false;
  }
};
